import { dataCalendarHeartSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconCalendarHeartSolid = /*#__PURE__*/createIcon(dataCalendarHeartSolid)
export default IconCalendarHeartSolid
